import { combineReducers } from 'redux';

import { tripsTabReducer } from './containers/TripsTabContainer/services/reducer';
import { tripReducer } from './containers/TripContainer/services/reducer';

export const orderingModuleReducer = combineReducers({
  tripReducer,
  tripsTabReducer,
});

export type OrderingModuleState = ReturnType<typeof orderingModuleReducer>;
